"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.codeComputeSetFunctionCallbackById = void 0;
const short_uuid_1 = __importDefault(require("short-uuid"));
const uuid_1 = require("uuid");
const googleMapsDecodePolylineString_1 = __importDefault(require("./googleMapsDecodePolylineString"));
const stringDecodeAsBase64_1 = __importDefault(require("./stringDecodeAsBase64"));
const stringEncodeAsBase64_1 = __importDefault(require("./stringEncodeAsBase64"));
const mapPolygonCheckIfCoordinatesAreInside_1 = __importDefault(require("./mapPolygonCheckIfCoordinatesAreInside"));
const recordAt_1 = __importDefault(require("./recordAt"));
const timestampToStringFromUnknown_1 = __importDefault(require("./timestampToStringFromUnknown"));
const callbacksByFunctionId = {};
const codeComputeSetFunctionCallbackById = (functionId, callback) => {
    callbacksByFunctionId[functionId] = callback;
};
exports.codeComputeSetFunctionCallbackById = codeComputeSetFunctionCallbackById;
const codeComputeGetApphiveObject = (functionId) => Object.freeze({
    google: Object.freeze({
        maps: Object.freeze({
            decodePolyline: googleMapsDecodePolylineString_1.default,
        }),
    }),
    string: Object.freeze({
        decodeAsBase64: stringDecodeAsBase64_1.default,
        encodeAsBase64: stringEncodeAsBase64_1.default,
        shortUuid: short_uuid_1.default.generate,
        uuid: uuid_1.v1,
    }),
    maps: Object.freeze({
        polygon: Object.freeze({
            coordinateIsInside: mapPolygonCheckIfCoordinatesAreInside_1.default,
        }),
    }),
    fn: {
        callCallback: (name, params) => {
            const callback = (0, recordAt_1.default)(callbacksByFunctionId, functionId);
            callback === null || callback === void 0 ? void 0 : callback(name, params);
        },
    },
    timestamp: Object.freeze({
        toString: timestampToStringFromUnknown_1.default,
    }),
});
exports.default = codeComputeGetApphiveObject;
